/**
 * The lobby's admin: whoever created it, i.e. the earliest to join who is
 * still there. The admin picks the match settings and starts the match even
 * when phop's lobby host (the lowest-sorted peer id, who runs the sim) is
 * someone else. If the admin leaves, the next-earliest takes over.
 *
 * Join order comes from the signalling server's peer list (`useRoom().peers`,
 * in the order peers joined), which every peer sees alike.
 */
export function lobbyAdmin(
  joinOrder: readonly string[],
  players: readonly string[]
): string | undefined {
  return joinOrder.find((p) => players.includes(p));
}
